export const bigProjectsList: Project[] = [
  {
    header: "Flowmodoro.com",
    description: "A productivity app that helps you make daily progress towards your goals",
    href: "https://flowmodoro.com",
    imageSrc: "/assets/portfolio/flowmodoro.png",
  },
  {
    header: "OneADayGames.com",
    description: "A new game to play - every day!",
    href: "https://oneadaygames.com",
    imageSrc: "/assets/portfolio/oneadaygames.png",
  },
];

export const miniProjectsList: Project[] = [
  {
    header: "By The Numbers",
    description:
      "A math-logic puzzle game where trivia facts reveal numbers. Arrange them in a 3x3 grid to match row and column totals!",
    href: "/by-the-numbers",
    imageSrc: "/assets/portfolio/ByTheNumbers.png",
  },
  {
    header: "Who's that Pokemon?",
    description: "A game based on the segment 'Who's that Pokemon'",
    href: "/whos-that-pokemon",
    imageSrc: "/assets/portfolio/whos-that-pokemon.png",
  },
];

export const pico8ProjectsList: Project[] = [
  {
    header: "ZombieRunway",
    description: "A game where you can only turn right and shoot zombies",
    href: "https://meeseeksoohwee.itch.io/zombierunway",
    imageSrc: "/assets/portfolio/zombierunway_0.gif",
  },
];

export const godotProjectsList: Project[] = [
  {
    header: "Tanks",
    description: "A tank game where you shoot aliens",
    href: "https://meeseeksoohwee.itch.io/tanks",
    imageSrc: "/assets/portfolio/tanks.png",
  },
];

export const experimentsList: Project[] = [
  ...miniProjectsList,
  ...pico8ProjectsList,
  ...godotProjectsList,
];

export interface Project {
  header: string;
  description: string;
  href: string;
  imageSrc: string;
}
